import type {
  PracticeSessionQuestion
} from '@repo/api-client/content-management-service';

// The numbered question dots above a practice question, coloured by the
// question's state in the session. They wrap rather than scroll sideways: a
// 17-question topic is two rows of smaller dots on a 360 px phone (QA,
// 9 October 2026: dot 10 on was cut off), one row of full-size dots from sm
// up. Each dot keeps a 32 x 40 px tap target on a phone.

export function PracticeQuestionDots({
  questions, states, current, onGo
}: {
  questions: readonly { id: string }[]
  states: Record<string, PracticeSessionQuestion | undefined>
  current: number
  onGo: (index: number) => void
}) {

  return (
    <nav aria-label="Questions" className="flex flex-wrap gap-y-1 sm:gap-1 w-full sm:w-auto max-w-full">
      {questions.map((q, i) => {

        const state = states[q.id]?.status;
        const colour = state === 'correct'
          ? 'bg-emerald-500 text-white border-emerald-500'
          : state === 'revealed'
            ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 border-amber-200 dark:border-amber-800'
            : state === 'skipped'
              ? 'bg-white dark:bg-gray-900 text-gray-500 border-gray-400 border-dashed dark:border-gray-500'
              : state === 'attempted'
                ? 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-gray-700'
                : 'bg-white dark:bg-gray-900 text-gray-500 border-gray-200 dark:border-gray-700';

        return (
          <button
            key={q.id}
            type="button"
            onClick={() => onGo(i)}
            aria-current={i === current ? 'step' : undefined}
            aria-label={`Question ${ i + 1 }${ state && state !== 'unseen' ? `, ${ state }` : '' }`}
            className="group shrink-0 flex h-10 w-8 sm:h-11 sm:w-9 items-center justify-center rounded-full focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-[rgb(1,158,250)]"
          >
            <span className={`flex w-7 h-7 sm:w-8 sm:h-8 items-center justify-center rounded-full text-xs font-semibold border transition-colors motion-reduce:transition-none ${ colour } ${ i === current ? 'ring-2 ring-[rgba(1,158,250,0.7)]' : '' }`}>
              {i + 1}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
